// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"1e54019a","223":"abafab88","384":"6d3a6bb0","564":"a6660386","653":"7a0011ba","829":"13087282","847":"2f958e37","915":"7bc49aac"}[chunkId] + ".chunk.js";
};